import { AxiosRequestConfig } from 'axios';
import { useCreateQuery, QueryOptions } from '../../CRUD';
import { axiosService } from '../../services';
import { filterKeys } from './keys';
import { UIFiltersStorage } from './types';

const fetch = async (params?: AxiosRequestConfig['params']) => {
  const { data } = await axiosService.get('/users/filters', { params });
  return data;
};

export const useFetchFilter = (
  params?: AxiosRequestConfig['params'],
  options?: QueryOptions<AxiosRequestConfig['params']>,
) =>
  useCreateQuery<UIFiltersStorage>(
    [...filterKeys.many()],
    fetch,
    params,
    options,
  );
